enum MediaitemUsageType {
  GOAL_THUMBNAIL = 'GOAL_THUMBNAIL',
  AVATAR = 'AVATAR',
  TASK = 'TASK',
  TASK_ASSIGNMENT = 'TASK_ASSIGNMENT',
  VOICE_CLONER = 'VOICE_CLONER',
  MESSAGE_ATTACHMENT = 'MESSAGE_ATTACHMENT',
  MENTOR_ATTACHMENT = 'MENTOR_ATTACHMENT',
  IMPROVER_ATTACHMENT = 'IMPROVER_ATTACHMENT'
}

enum MediaitemType {
  IMAGE = 'IMAGE',
  GIF = 'GIF',
  SVG = 'SVG',
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
  DOCUMENT = 'DOCUMENT',
  ARCHIVE = 'ARCHIVE'
}

enum MediaitemFileRole {
  THUMBNAIL = 'THUMBNAIL',
  DISPLAY = 'DISPLAY',
  ORIGINAL = 'ORIGINAL',
  AUXILIARY = 'AUXILIARY',
  TRANSCRIPT = 'TRANSCRIPT'
}

enum MediaitemFileQuality {
  QUALITY_720P = '720p',
  QUALITY_480P = '480p',
  QUALITY_240P = '240p',
  NOT_SET = 'NOT_SET',
  VIMEO = 'VIMEO'
}

interface CreateMediaitemModel {
  type: MediaitemType;
  usageType: MediaitemUsageType;
  basePath: string;
  contentType: string;
  originalFilename?: string;
}

interface MediaitemFileModel {
  id: number;
  role: MediaitemFileRole;
  quality: MediaitemFileQuality;
  url: string;
  contentType: string;
  size: number;
  height: number;
  width: number;
  ready: boolean;
  duration: number;
  rotation: number;
  originalFilename: string | null;
}

interface MediaitemModel {
  id: number;
  authorId: number;
  createdAt: string;
  updatedAt: string;
  type: MediaitemType;
  usageType: MediaitemUsageType;
  files: MediaitemFileModel[];
}

interface MediaitemSignedUploadModel {
  uploadUrl: string;
  basePath: string;
}

export { MediaitemFileQuality, MediaitemFileRole, MediaitemType, MediaitemUsageType };
export type {
  CreateMediaitemModel,
  MediaitemFileModel,
  MediaitemModel,
  MediaitemSignedUploadModel
};
